(function () {
    angular.module('tmx-app').controller('ecibDetailController', ['$scope', '$http', 'TMX_FINANCE_CONSTANTS', 'dynamicFormService', 'lookupService', 'tmxUtility', 'tmxResource', 'cacheStore','ToastService',

        function ecibDetailController($scope, $http, TMX_FINANCE_CONSTANTS, dynamicFormService, lookupService, tmxUtility, tmxResource,cacheStore,ToastService) {
            var ecibDetailVM = $scope;
            var exists;
            exists = tmxUtility.exists;
            ecibDetailVM.FRMUData = {};
            ecibDetailVM.applicationData = dynamicFormService.applicationData;
            ecibDetailVM.slsformChange = slsformChange;
            ecibDetailVM.cnic = ecibDetailVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue;
            if(ecibDetailVM.cnic)
                ecibDetailVM.pdfPath = "assets/eCIB/Output/" + ecibDetailVM.cnic + ".pdf";
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
            var productId = ecibDetailVM.applicationData.LoanProductId || ecibDetailVM.applicationData.ProductId;
            var otherCompanyLkpId = "";
            var COMPANY_SEGMENT = [];
            var LoggedInUserConfigurations =  cacheStore.get("Configurations");	
            ecibDetailVM.isEcibFetched = false;
            //#region  ----------Private Functions ----------------------------
            function getUniqueHistoryType(LoanDetails) {
                if (exists(LoanDetails) && exists(LoanDetails.TmxeCIBDetailHistoryMap)) {
                    var ecibHistoryType = LoanDetails.TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.map(a => a.HistoryType);
                    if (ecibHistoryType)
                        return ecibHistoryType.filter(onlyUnique);
                }
                return "";
            }

            function getValueByProductDataObj(product, date, obj) {
                if (obj.TmxeCIBDetailHistoryMap != null)
                    obj = obj.TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.filter(a => a.HistoryType == product && a.OverdueDate == date)[0];
                if (obj) {
                    return obj.Amount;
                }
                else {
                    return 0;
                }
            }

            function slsformChange() {
                $scope.$emit("reloadApplicationData",""); 
            }

            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }
            function getecibReport(){
                if (ecibDetailVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue) {
                    return "assets/eCIB/Output/" + ecibDetailVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue + ".pdf";
                }
                else {
                    ToastService.showCustomToast('error', 'CNIC not found');
                }
            }
            ecibDetailVM.downloadECIB = function () {
                if (ecibDetailVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue) {
                    window.open(ENV.ecibURL + ecibDetailVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue + '.pdf', '_blank');
               // $window.location.href = (ENV.ecibURL + ecibDetailVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue + '.pdf');
                }
                else {
                    ToastService.showCustomToast('error', 'CNIC not found');
                }
            //return (ENV.ecibURL + ecibDetailVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue + '.pdf');
            }
            ecibDetailVM.attachECIBDoc = function () {
                try {
                    if (!(ecibDetailVM.applicationData && ecibDetailVM.applicationData.TmxCustomerMaster.length > 0
                        && ecibDetailVM.applicationData.TmxCustomerMaster[0].EcibFetchFlag == '1')) {
                        ecibDetailVM.isEcibFetched = false;
                        ToastService.showCustomToast("error", "Please fetch ECIB first.");
                        return;
                    }
                    $http.get(ecibDetailVM.pdfPath, { responseType: 'blob' }).success(function (res) {
                        if (res) {
                            $scope.$emit("loading", "true");
                            const reader = new FileReader();
                            reader.onloadend = function (event) {
                                var base64data = reader.result.split('base64,')[1]
                                var applicationCheckListObj = ecibDetailVM.findAccountApplicationChecklist(ecibDetailVM.ecibProductChecklistId, ecibDetailVM.applicationData.TmxLoanApplicationChecklist);
                                if(!applicationCheckListObj)
                                {
                                    ToastService.showCustomToast("error", "Document not found in Checklist.");
                                    $scope.$emit("loadingComplete", "");
                                    return;
                                }
                                var applicationChecklistImageViewModel = {
                                    LoanApplicationChecklistId: applicationCheckListObj.LoanApplicationChecklistId,
                                    AttachmentURL: 'Dummy Attachment URL',
                                    FileData: base64data,
                                    ImageData: "Empty Image Data",
                                    MimeType: "application/pdf"
                                };
                                tmxResource('LoanApplication').getByAction('UploadFile', false, 'post', applicationChecklistImageViewModel).then(function (response) {
                                    if (response && response.data && response.status && response.status.code == 200) {
                                        applicationCheckListObj.AttachmentURL = response.data.AttachmentURL;
                                        applicationCheckListObj.MimeType = response.data.MimeType;
                                        dynamicFormService.applicationData.TmxLoanApplicationChecklist = ecibDetailVM.applicationData.TmxLoanApplicationChecklist;
                                        ToastService.showCustomToast("success", "ECIB attached succesfully.");
                                        $scope.$emit("reloadDocuments", "");
                                    }
                                    else
                                        ToastService.showCustomToast("error", "Error uploading ECIB. Please try again");


                                    $scope.$emit("loadingComplete", "");
                                });

                            }
                            reader.readAsDataURL(res);
                        }
                        else {
                            ToastService.showCustomToast("error", "ECIB File not found. Please try again");
                            $scope.$emit("loadingComplete", "");
                        }
                    });
                } catch (err) {
                    ToastService.showCustomToast("error", "Error uploading ECIB. Please try again");
                    $scope.$emit("loadingComplete", "");
                }
            }
            ecibDetailVM.getECIB = function () {
                // eslint-disable-next-line no-undef
                if(ecibDetailVM.cnic && ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth) {
                    var EligibilityRequestViewModel = {
                    
                        "loanAppId" : ecibDetailVM.applicationData.LoanApplicationId,
                        "CNIC": ecibDetailVM.cnic,//"4210113379199",
                        "DOB": tmxUtility.formatDateSpecific(ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth, "YYYY-MM-DD")
                        //ecibDetailVM.formatDate(ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth)
                    }
                    tmxResource('Integration').getByAction('FetchAndStoreECIB', false, 'post', EligibilityRequestViewModel).then(function (response) {
                        if (response && response.data && response.status) {
                            if(response.status.code=="200" || response.status.code=="204") {
                                ecibDetailVM.applicationData = response.data;
                                dynamicFormService.applicationData.TmxCustomerMaster[0].TmxECIBDetail = response.data.TmxCustomerMaster[0].TmxECIBDetail;
                                dynamicFormService.applicationData.TmxCustomerMaster[0].EcibFetchFlag = response.data.TmxCustomerMaster[0].EcibFetchFlag;
                                $scope.$emit("reloadECIBData", "");
                                ecibDetailVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue = ecibDetailVM.cnic;
                                if(ecibDetailVM.cnic)
                                    ecibDetailVM.pdfPath = "assets/eCIB/Output/" + ecibDetailVM.cnic + ".pdf";
                                ecibDetailVM.isEcibFetched = true;
                            }
                            else {
                                ecibDetailVM.applicationData.TmxCustomerMaster[0].NationalIdentifierValue = ecibDetailVM.cnic;
                                if(ecibDetailVM.cnic)
                                    ecibDetailVM.pdfPath = '';
                                ToastService.showCustomToast("error",response.status.message);
                                ecibDetailVM.isEcibFetched = false;
                            }
                        }
                    });
                }
                else
                    ToastService.showCustomToast("error","CNIC & Date Of Birth is required+");
            }
           

            function InitializeLookups() {
                lookupService.getLookupByType(lkupType.COMPANY).then(function (response) {
                    ecibDetailVM.Company = response;


                    otherCompanyLkpId = ecibDetailVM.Company.filter(function (obj) {
                        return obj.VisibleValue.toLowerCase() == 'other';
                    });
                    otherCompanyLkpId = otherCompanyLkpId[0] ? otherCompanyLkpId[0].LookupId : "";

                    ecibDetailVM.Company.forEach(function (item) {
                        if (item.HiddenValue.toLowerCase() != 'other') {
                            item.LookupId = item.HiddenValue;
                        }
                    });

                    if (ecibDetailVM.applicationData.TmxCustomerMaster[0] && ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0] && ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson && ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0] && ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer) {
                        var selectedCompanyName = ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
                        var CompanyList = ecibDetailVM.Company.filter(function (item) {
                            return item.HiddenValue == selectedCompanyName
                        });
                        if (CompanyList.length < 1) {
                            ecibDetailVM.Company.push({
                                LookupId: selectedCompanyName,
                                HiddenValue: selectedCompanyName,
                                VisibleValue: selectedCompanyName
                            });
                        }
                    }
                });
                lookupService.getLookupByType(lkupType.COMPANY_SEGMENT).then(function (response) {
                    ecibDetailVM.COMPANY_SEGMENT = response;
                    COMPANY_SEGMENT = angular.copy(ecibDetailVM.COMPANY_SEGMENT);
                });


                lookupService.getLookupByType(lkupType.CUST_SEGMENT).then(function (response) {
                    ecibDetailVM.CUST_SEGMENT = response;
                });

                lookupService.getLookupByType(lkupType.TYPE_OF_JOB).then(function (response) {
                    ecibDetailVM.TYOE_OF_JOB = response;
                });

                lookupService.getLookupByType(lkupType.LOCATION_TYPE_CITY).then(function (response) {
                    ecibDetailVM.LOCATION_TYPE_CITY = response;
                });
                ecibDetailVM.IdentifierLkp = lookupService.getLocalLookupsByType(lkupType.ID_TYPE);

                ecibDetailVM.CriteriaLkp = lookupService.getLocalLookupsByType(lkupType.CustomerCriteria);
            }

            function InitializeData() {
                if (exists(ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxECIBDetail)) {
                    ecibDetailVM.ecibLoanDetails = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxECIBDetail;

                    var filteredList = ecibDetailVM.ecibLoanDetails.find(x => x.TmxeCIBDetailHistoryMap);
                    if (exists(filteredList) && exists(filteredList.TmxeCIBDetailHistoryMap)) {
                        ecibDetailVM.ecibHistoryDateArray = filteredList.TmxeCIBDetailHistoryMap.TmxeCIBDetailHistory.map(a => a.OverdueDate).filter(onlyUnique);
                    }

                }
                ecibDetailVM.isEcibFetched = ecibDetailVM.applicationData.TmxCustomerMaster[0].EcibFetchFlag == '1';
                if (!ecibDetailVM.isEcibFetched) {
                    ecibDetailVM.pdfPath = '';
                }
                else {
                    ecibDetailVM.pdfPath = "assets/eCIB/Output/" + ecibDetailVM.cnic + ".pdf";
                }
               
            }
            function ReadConfigurations(){
                ecibDetailVM.showDbrTenureField =tmxUtility.getConfigurationValue(LoggedInUserConfigurations,'DBR_TENURE_MONTHS',true,productId) == true;
                ecibDetailVM.showCriteriaField =tmxUtility.getConfigurationValue(LoggedInUserConfigurations,'SHOW_CRITERIA_SELECTION',true,productId) == true;
                ecibDetailVM.ecibAttachPdf = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'ECIB_PDF_TO_ATTACH', true, productId);
                ecibDetailVM.ecibProductChecklistId = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'ECIB_PDF_PRODUCT_CHECKLIST_ID', true, productId);
                
            }

            //#endregion


            //#region ------ Scope functions------------------


            $scope.formatDate = function (dateTime) {
                if (dateTime) {
                    //var date= new Date(dateTime + 'Z');
                    var date = new Date(dateTime);
                    var month = date.getUTCMonth() + 1; //months from 1-12
                    var day = date.getUTCDate();
                    var year = date.getUTCFullYear();
                    return day + "/" + month + "/" + year;
                }
                else {
                    return 'N/A';
                }
            }
          
            ecibDetailVM.findAccountApplicationChecklist = function (productId, TmxLoanApplicationChecklist) {
                var LoanApplicationChecklist = null;
                TmxLoanApplicationChecklist.forEach(function (dataItem) {
                    if (productId == dataItem.LoanProductChecklistId)
                        LoanApplicationChecklist = dataItem;
                })
                return LoanApplicationChecklist;
            }
            //#endregion

            $scope.$on("reloadSlsAndFrmuData", function () {

                ecibDetailVM.applicationData = dynamicFormService.applicationData;
                findPersonIncomeDetailIndex();
                manipulateBtfFlag();
                // $scope.resourceForEcibGrid = dynamicFormService.applicationData.TmxCustomerMaster[0].TmxECIBDetail;
                if (!ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness) {
                    ecibDetailVM.applicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = null;
                }
            });

            (function InitializePage(){
                InitializeData();
                InitializeLookups();
                ReadConfigurations();
            })();

            //#region -----Child controllers-----------
          

            //#endregion

        }]);
})();